<template>
  <div class id="app">
    <!-- <div style="background: #353535; color: #8cff1a">
      <h2>themes {{ themes.current() }}</h2>
    </div> -->
    <!-- userStore.isAuthenticated {{ userStore.isAuthenticated }} -->

    <div v-if="devDesign" style="background: darkblue; color: cyan; padding: 3px">
      <b-row no-gutters>
        <b-col cols="2"
          ><h5>MOUSE: X : {{ x }} Y : {{ y }}</h5></b-col
        >
        <!-- <b-col cols="2"><h5>themes {{ themes.current() }}</h5></b-col> -->
        <b-col cols="2"><h2></h2></b-col>
        <b-col cols="2"><h2></h2></b-col>
      </b-row>
    </div>

    <div v-if="userStore.isAuthenticated" class="layout">
      <div v-if="AreIdsShown">isHCCRoute {{ isHCCRoute }}</div>
      <div>
        <SearchLoginSecurity class="pt-1" @rteName="sendClkToDASH" />
        <AppNavbar />
        <PatientInfobar v-if="patientStore.currentPatientId > 0 && isHCCRoute" />
      </div>

      <div v-if="testingBoot">
        <div v-if="testingBoot" style="background: #3fbc38; color: yellow">
          userStore {{ userStore._user.fullName }} <br />
          {{ userStore._user.name }}
        </div>
        <div v-if="testingBoot" style="background: #7c7014; color: yellow">userStore {{ userStore._user }}</div>

        <div v-if="testingBoot">
          <b-badge variant="inspinia">inspinia</b-badge>
          <b-badge variant="primary-green">primary-green</b-badge>
          <b-badge variant="DaVinci">DaVinci</b-badge>
          <b-badge variant="primary">Primary</b-badge>
          <b-badge variant="primary">Primary</b-badge>
          <b-badge variant="secondary">Secondary</b-badge>
          <b-badge variant="success">Success</b-badge>
          <b-badge variant="danger">Danger</b-badge>
          <b-badge variant="warning">Warning</b-badge>
          <b-badge variant="info">Info</b-badge>
          <b-badge variant="light">Light</b-badge>
          <b-badge variant="dark">Dark</b-badge>
        </div>

        <div v-if="testingBoot" class="pTest">
          PTEST
          <b-button variant="inspinia">inspinia</b-button>
          <b-button variant="primary-green">primary-green</b-button>
          <b-button variant="dark-green">dark-green</b-button>
          <b-button variant="dark-greenSummary">dark-greenSummary</b-button>
          <b-button variant="dark-yellow">dark-yellow</b-button>
          <b-button variant="d-yellow">d-yellow</b-button>
          <b-button variant="dark-orange">dark-orange</b-button>
          <b-button variant="dark-blue">dark-blue</b-button>
          <b-button variant="primary-white">primary-white</b-button>
          <b-button variant="primary-light-gray">primary-light-gray</b-button>
          <b-button variant="primary-light-gray">primary-light-gray</b-button>
          <b-button variant="primary-gray">primary-gray</b-button>
          <b-button variant="DaVinci">DaVinci</b-button>
        </div>
      </div>

      <div class="flex-container">
        <div class="content">
          <RouterView />
        </div>
      </div>
    </div>
    <div v-else>
      <Landing />
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted, reactive, toRaw, computed } from "vue";

// import config from "devextreme/core/config";
// import { licenseKey } from "./devextreme-license";

// config({ licenseKey });

// import { getToken } from "@/config/authService";

// * STOREs
import { useStoreWorkList } from "@/stores/workListsStore";
const workListStore = useStoreWorkList();
// * STORE
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();

// & ROUTER
import { RouterLink, RouterView, useRoute, useRouter } from "vue-router";

import Landing from "./views/Landing.vue";

const router = useRouter();
const route = useRoute();

const currentRouteName = computed(() => route.name); // ROUTE.NAME

// ! ROUTE path INCLUDES a computed ref
const isHCCRoute = computed(() => route.path.includes("/Patient"));

// console.log("                         route");
// console.log(route);

// console.log("isHCCRoute");
// console.log(isHCCRoute);

import BLANKgrid from "./components/BLANKgrid.vue";

// import themes, { init } from "devextreme/ui/themes";
// set current theme from userStore devextheme
// if (userStore._user && userStore._user.devExTheme) {
//   themes.current(userStore._user.devExTheme);
// } else {
//   // Fall back to saved theme or default
//   themes.current(savedTheme);
// }

// themes.current("generic.dark");
// themes.current("generic.light.compact");
// themes.current("generic.dark.compact");
// themes.current("generic.general-light-blue-scheme");
// themes.current("generic.general-dark-blue-scheme");

// init(); // Initialize themes if needed
// ^ Default theme fallback
// const savedTheme = localStorage.getItem("dx-theme") || "generic.light.white";

// themes.current(savedTheme);
// themes.current("generic.contrast.compact");

// When using SVG components
// import { refreshTheme } from "devextreme/viz/themes";
// refreshTheme();

import SearchLoginSecurity from "./components/SearchLoginSecurity.vue";
import AppNavbar from "./components/AppNavbar.vue";
import TodaysPatients from "./views/TodaysPatients.vue";
import PatientInfobar from "./components/PatientInfobar.vue";

import NavLIST from "@/NavLIST.vue";

import DxDrawer from "devextreme-vue/drawer";
import DxRadioGroup from "devextreme-vue/radio-group";
import DxToolbar from "devextreme-vue/toolbar";
import NavigationList from "./NavigationList.vue";
import { text } from "./tempData";

// & COMPOSIBLEs
import { initializeTheme } from "@/use/themeUtils.js";
// initializeTheme();
import { useMouse } from "@/use/mouse.js";
const { x, y } = useMouse();

const devDesign = ref(false);

const showModes = ["push", "shrink", "overlap"];
const positionModes = ["left", "right"];
const showSubmenuModes = ["slide", "expand"];

const selectedOpenMode = ref("shrink");
const selectedPosition = ref("left");
const selectedRevealMode = ref("slide");
const openState = ref(true);

const toolbarContent = [
  {
    widget: "dxButton",
    location: "before",
    options: {
      icon: "menu",
      stylingMode: "text",
      onClick: () => {
        openState.value = !openState.value;
      },
    },
  },
];

// import DxDrawer from 'devextreme-vue/drawer';
// import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';

import DashboardPageOne from "./components/DashboardPageOne.vue";

const redirectUri = import.meta.env.VITE_REDIRECT_URI;
const clientId = import.meta.env.VITE_CLIENT_ID;
const tenantId = import.meta.env.VITE_TENANT_ID;

// console.log(redirectUri);
// console.log(clientId);
// console.log(tenantId);
// console.log(import.meta.env.VITE_TEST_VAR);

const isOutsideLSBOpen = ref(false);

const oldAppLayout = ref(true);

// console.log("isOutsideLSBOpen");
// console.log(isOutsideLSBOpen.value);

const menuTEST = ref([
  {
    header: "Physicians Console",
    hiddenOnCollapse: true,
  },
  {
    header: false,
    attributes: { hidden: false },
    href: `/Patient/${patientStore.currentPatientId}/`,
    title: "Chart: " + patientStore.currentPatientId,
    icon: "fa fa-notes-medical",
    hiddenOnCollapse: true,
    child: [
      {
        href: `/Patient/${patientStore.currentPatientId}/inpatient`,
        title: "app In-Patient",
        icon: "fa fa-ambulance",
        badge: {
          text: 1234,
          class: "badge badge-success",
          attributes: { hidden: false },
          // attributes: {}
          // element: 'span'
        },
      },
      {
        href: `/Patient/${patientStore.currentPatientId}/vitals`,
        title: "Vitals",
        icon: "fa fa-heart",
        hidden: !userStore.hasFullPatientChart,
        badge: {
          text: 444,
          class: "badge badge-success",
          attributes: { hidden: false },
        },
      },
    ],
  },
]);

function sendClkToDASH(payload) {
  // console.log(" LAY emit/Rcv  sendClkToDASH");
  // console.log(payload);
  // console.log("============");
  // // console.log('this.$root.$refs')
  // // console.log(this.$root.$refs)

  // this.$root.on('rteName', () => this.$root.$refs.Btn.click())

  // console.log(" CHECK Payload BEFORE store to SEND $router.go");

  if (!payload) {
    // console.log(" 			GET  						  workListStore.getWidgetSummaryListFromAPI()	>>>>>       ");
    // this.$router.go(this.$router.currentRoute)
    // router.go(0)

    workListStore.getWidgetSummaryListFromAPI();
  }
  // // console.log(" 											>>>>>  SWTCHIING ROUTES           router.go(0)        ");
  // this.$router.go(this.$router.currentRoute)
  // router.go(0)

  // console.log("				 STORE    setDashPagesBOO >>>>>>>>>>>>>>>>>> ");
  // this.$store.commit("setDashPageBooleam", payload);

  userStore.setDashPageBooleam(payload);
}

function addPatientToArray(selectedWidget) {
  // // console.clear()
  // console.log("            LAYOUT    >>>>>>>>>>>>>>>          -----------------------------ADD PATIENT > :");
  // console.log("selectedWidget");
  // console.log(selectedWidget);

  // // console.dir(this.currentPatient)

  // this.localPatientList.push(this.currentPatient)

  // console.log(". add currentPatient TO ARRAY");

  // this.$store.commit('addPatientToArray', this.currentPatient)

  // patientStore.addPatientToArray(toRaw(patientStore.currentPatient))
  // patientStore.addPatientToArray(JSON.stringify(patientStore.currentPatient))

  patientStore.addPatientToArray(JSON.stringify(selectedWidget));

  // console.log("****************************************************");
  // console.log("		***			>>>>>>>>>>>>>>>>>>    STORE  		  													setCurrentPatient	 this.currentPatient");

  // // console.log('patientArray Selected:')
  // // console.log(patientStore.patientArray)

  // this.$store.commit('addPatientToChart', this.currentPatient)

  // // console.log('patientList Selected:')
  // // console.log(this.patientList)
}

// onBeforeMount(() => {

//   themes.current(savedTheme);

//   // Safety check before setting theme
//   try {
//     // Avoid calling themes.current() with null
//     if (userStore._user && userStore._user.devExTheme) {
//       themes.current(userStore._user.devExTheme);
//     } else {
//       themes.current(savedTheme);
//     }
//   } catch (error) {
//     console.warn("Theme initialization error:", error);
//     // Fallback to a known valid theme
//     themes.current("generic.light");
//   }
// });

onMounted(async () => {
// console.log("onMounted() :   PHYSICIANS CONSOLE  APP >>>>>");
  // initializeTheme();
  // console.clear();
  // console.log("  APP       themes ccheck        *");
  // console.log(themes.current());
  // try {
  //   // Attempt silent login on component mount
  //   console.log(" APP mount:  getToken()  REQUIRED to cycle past LANDING >>>>>>")
  //   const token = await getToken();
  //   if (token) {
  //     console.log(" >>>>>>>>>>>>>>>>>>>>>>>                                                        [TheWelcome.vue] Silent login successful, token:   FOUND");
  //     // // console.log(" >>>>>>>>>>>>>>>>>>>>>>>                                                        [TheWelcome.vue] Silent login successful, token:", token);
  //     //await getUserData(); // Only call if authenticated
  //   }
  // } catch (e) {
  //   console.log("                    Silent login failed:", e);
  //   // Optionally, handle errors or show a message
  // }


});

// Boolean ref
const AreIdsShown = ref(false);
const testingBoot = ref(false);

function changeMe() {
  AreIdsShown.value = !AreIdsShown.value;
}
</script>

<style lang="scss">
// @import "@/assets/css/main.scss";

// * APP
#app {
  background-color: #b0c1b2;
  padding: 0px;
  //  padding-top: 0px;
  height: 100%;
  width: 100%;
  //	max-width: 1920px;
  //	max-height:1080px;
  background-color: var(--usersVariant);
  overflow: hidden;
  background: transparent;
}
#app2 {
  background: green;
  padding: 6px;
}
.layout {
  background-color: var(--usersVariant);
  background: #c6d9c8;

  background: #353535;
  background: transparent;
  //padding:$diet-padding;

  //* HEIGHT LOCK - NO VERT SCROLL
  //height: 660px;
  height: 100%;
  //  overflow: hidden;
  //  padding:6px;
  //bad	padding:var(--strDietPadding);
}

.top-rows {
  padding: 0 0rem;
  // margin-left: -1rem;
  // margin-right: -1rem;
//  background: $inspinia-green;
  background: transparent;
  // height: 100px !important;
}

.content {
  background: transparent;
  padding: 00px;
  height: 100%;
}

.router-view {
  //background-color: rgb(201, 255, 4);
  border: 0px solid transparent;

  background: transparent;
  padding: 0px;
  //width: 100%;
  //height: 100%;
}

.worklists-active {
  -webkit-box-shadow: 1px 0px 0px 0px transparent inset;
  box-shadow: 1px 0px 0px 0px transparent inset;

  // height: 24px;
  color: #123486;
  background-color: #dcf1de; //a5dbaa;
  // border-radius: 5px 5px 5px 5px;
  // border-width: 3px 0px 3px 6px;
  font-weight: bolder;
  // height: 25px;
}

.nav-link {
  display: block;
  padding-top: 0px;
  padding-bottom: 0px;

  // width: 130px;
}

.nav-link:hover,
.nav-link:focus {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.navCont .nav-link .nav-pills {
  line-height: 40px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  text-align: center;
  // color: orange;
  font-size: 1rem;
  border-radius: 10px 0px 0px 10px;
  // height: 140px;
  width: 30px;
  width: 300px;
  color: #123486;
  border-radius: 10px 0px 0px 10px;
  background-color: transparent;
}

.nav-pills {
  background-color: transparent; // #c6d9c8;
}

.nav-pills .nav-link.active {
  height: 24px;
  color: #123486;
  background-color: #a5dbaa;
  // border-radius: 5px 5px 5px 5px;
  // border-width: 3px 0px 3px 6px;
  font-weight: bolder;
}

.nav-pills .nav-link {
  border-radius: 0px;
  text-align: center;
}

.testDIV {
  background: darkblue;
  color: cyan;
  width: 300px;
  height: 150px;
}

//.dx-overlay-content {
//  background-color: rgb(120, 4, 4);
//  background: #06379a; //#849185;
//}

.sidebar {
  // flex-basis: 10%;
  margin-top: 0px;
  padding-top: 0px;

  flex-basis: 10%;
  background: transparent;
  padding: 00px;
  //  min-width: 125px;
  //  width: 125px;
  //height:fit-content;
}
.content {
  flex-basis: 90%;
}
.pTest {
  //  background: var(cColor);
//  color: $inspinia-green; //$primary-dark-blue $inspinia-green
  padding: 12px;
  padding: 0%;
//  background: $clinician-desktop-dark-green;
}
#test {
  --var-txt-color: #d32f9f;
  color: var(--var-txt-color);
  font-size: large;
}
.test {
  background: transparent;
}
.test-child-node {
  background: var(--var-txt-color);
}

.dx-toolbar {
  background-color: #b0c1b2; // rgb(255, 196, 0);
  padding: 2px 1px 5px 5px;
}

// .dx-list-item-content {
//  padding-left: 10px !important;
//  background-color: rgb(98, 87, 27);
// }
.dx-button {
  //  background-color: rgba(191, 191, 191, -0.15);
  border: none;
  //  background-color: #6e796f;
  color: white;
}
.panel-list {
  height: 400px;
}
.dx-drawer-expand.dx-drawer-right .panel-list {
  float: right;
}
.panel-list .dx-list-item {
  color: #fff;
  border-top: 1px solid rgba(221, 221, 221, 0.2);
}
.panel-list .dx-list-item .dx-icon {
  color: #fff !important;
}
.options {
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
}
.options-container {
  display: flex;
  align-items: center;
}
.caption {
  font-size: 18px;
  font-weight: 500;
}
.option {
  margin-top: 10px;
  display: inline-block;
  margin-right: 50px;
}
label {
  font-weight: bold;
  //  color: blue;
}
#content {
  height: 100%;
  //padding: 10px 20px;
}
#content h2 {
  font-size: 26px;
}
// * APP

// * temp
.demo-container {
  overflow: visible;
}

.flex-container {
  display: flex;
  flex-direction: column;
  background: transparent;
}

.dx-drawer-content {
  display: flex;
}

.panel-list {
  height: 400px;
  padding-top: 12px;
}

.options {
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
}

.options-container {
  display: flex;
  align-items: center;
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 10px;
  display: inline-block;
  margin-right: 50px;
}

#content {
  padding: 0 24px;
}

#content h2 {
  font-size: 26px;
}
</style>
